<div id="db-bug" *ngIf="database" [ngClass]="[database]" aria-hidden="true">
  DB: {{ database }}
</div>
<router-outlet></router-outlet>
